import type { ReactNode } from 'react';
import { useState } from 'react';

import * as styles from './settings-collapsible.css';

/** Collapsible section — default collapsed, toggles with click on header */
export const SettingsCollapsibleSection = ({
  title,
  testId,
  children,
}: {
  title: string;
  testId?: string;
  children: ReactNode;
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div data-testid={testId}>
      <button
        type="button"
        onClick={() => setExpanded(prev => !prev)}
        className={styles.header}
      >
        <span className={styles.caret}>{expanded ? '▼' : '▶'}</span>
        {title}
      </button>
      {expanded && children}
    </div>
  );
};
